import { Component, forwardRef, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BalanceService, CurrencyType } from '@app/core/balance.service';

interface CoinOption {
  value: CurrencyType;
  text: string;
}

@Component({
  selector: 'app-currency-selector',
  template: `
    <div class="selected" (click)="showCoins = !showCoins">
      <span class="icon coin coin-{{ value }}"></span> <span class="text">{{ getLabelByKey(value) }}</span>
      <span class="arrow"><i class="fas fa-chevron-down"></i></span>
    </div>
    <div class="options" *ngIf="showCoins">
      <ng-container *ngFor="let coin of list">
        <div class="option" *ngIf="coin.value !== value" (click)="value = coin.value; showCoins = false">
          <span class="icon coin coin-{{ coin.value }}"></span> <span class="text">{{ coin.text.toUpperCase() }}</span>
        </div>
      </ng-container>
    </div>
  `,
  styleUrls: ['./currency-selector.template.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CurrencySelectorComponent),
      multi: true,
    },
  ],
})
export class CurrencySelectorComponent implements OnInit, OnDestroy, ControlValueAccessor {
  @Input() ignoreCoins: CurrencyType[] = [];
  public showCoins: boolean = false;
  public items: CoinOption[] = [
    { value: CurrencyType.BTC, text: 'Bitcoin (BTC)' },
    { value: CurrencyType.ETH, text: 'Ethereum (ETH)' },
    { value: CurrencyType.LTC, text: 'Litecoin (LTC)' },
    { value: CurrencyType.EDG, text: 'Edgeless (EDG)' },
    { value: CurrencyType.DAI, text: 'FIAT (USD / EUR / GBP)' },
  ];
  private sub: Subscription = new Subscription();
  private _value: CurrencyType = this.balance.getCurrency();

  constructor(private balance: BalanceService) {}
  ngOnInit(): void {
    // this.sub.add(
    //   this.gs.currencyChange
    //     .pipe(filter((currency: PlayerCurrency) => currency !== this.value))
    //     .subscribe((currency: PlayerCurrency) => {
    //       this.value = currency;
    //     })
    // );
  }
  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {}

  onChange: any = () => {};

  onTouched: any = () => {};

  public get value() {
    return this._value;
  }

  public set value(v: CurrencyType) {
    this._value = v;
    this.onChange(this._value);
    this.onTouched();
  }

  public get list() {
    return this.items.filter(item => !this.ignoreCoins.includes(item.value));
  }

  writeValue(obj: any): void {
    this._value = obj;
  }

  getLabelByKey(key: CurrencyType): string {
    return this.items.find(item => item.value === key).text;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/template/modals/deposit/currency-selector.component.ts